/*eslint-disable*/
import React, { useState, useEffect, useContext } from "react";
import { useSelector, useDispatch } from "react-redux";
import {STYLES} from "config";
import { makeStyles } from "@material-ui/core/styles";
import AlertDialog from "../../../components/AlertDialog";
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  CardTitle,
  Label,
  FormGroup,
  Input,
  Row,
  Col,
  FormText,
  Container
  // Alert,
} from "reactstrap";
import FlatList from "flatlist-react";
import { FirebaseContext } from "common";
import { useLocation, useNavigate } from "react-router-dom";
const useStyles = makeStyles({
  root: {
    minWidth: 275,
    // border: "5px solid",
    // borderColor: STYLES.PRIMARY_APP_CLR,
    // borderBlockStartColor:STYLES.TERTIARY_APP_CLR,
    // borderBlockStart: "2px solid",
    // background: 'linear-gradient(45deg, #FE6B8B 30%, #FF8E53 90%)',
    flexDirection: "column",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    height: "100%"
  },
  Button: {
    width: 150,
    height: 40
  },
  ImgContainer: {
    borderRadius: "50",
    height: "75%",
    width: "100%",
    aspectRatio: "16/9"
  },
  Card: {
    width: "70%",
    padding: 10,
    minWidth: 275,
    border: "1px solid",
    borderColor: STYLES.PRIMARY_APP_CLR,
    borderRadius: 30
  },
  ImgCard: {
    width: "90%",
    border: "1px solid",
    borderColor: STYLES.PRIMARY_APP_CLR,
    borderRadius: 30
  },
  PriceText: { margin: "20px0 15px", color:STYLES.TERTIARY_APP_CLR, fontSize: 32 },
  propType: {
    margin: "20px0 15px",
    fontSize: 16,
    color: "grey"
  },
  detialsSmokey: {
    width: "100%",
    alignContent: "center",
    flexDirection: "row",
    height: 25,
    backgroundColor: "#dcdcdc",
    display: "flex",
    flexDirection: "row"
  },
  detials: {
    width: "100%",
    alignContent: "center",
    flexDirection: "row",
    height: 25,
    display: "flex",
    flexDirection: "row"
  },
  CardHeader: {
    flexDirection: "column",
    fontSize: 18,
    fontWeight: "400",
    color:STYLES.TERTIARY_APP_CLR,
    display: "flex",
    margin: 15
  },
  separator: {
    height: 1,
    width: "100%",
    backgroundColor:STYLES.TERTIARY_APP_CLR,
    alignSelf: "center",
    marginBottom: 15
  },
  InfoDescriptionText: {
    width: "50%",
    color:STYLES.SECONDARY_APP_CLR,
    flexDirection: "row",
    fontSize: 15,
    fontWeight: "700",
    marginBottom: 0
  },
  InfoText: {
    color:STYLES.SECONDARY_APP_CLR,
    flexDirection: "row",
    fontSize: 15,
    fontWeight: "300",
    marginBottom: 0
  },
  radioText: {
    width: "30%",
    color:STYLES.SECONDARY_APP_CLR,
    flexDirection: "row",
    fontSize: 15,
    fontWeight: "700",
    marginBottom: 0
  },
  separatorTwo: {
    height: 1,
    width: "100%",
    backgroundColor:STYLES.TERTIARY_APP_CLR,
    alignSelf: "center",
    marginBottom: 5
  },
  CardHeaderTwo: {
    flexDirection: "column",
    fontSize: 18,
    fontWeight: "400",
    color:STYLES.TERTIARY_APP_CLR,
    display: "flex",
    margin: 15
  }
});

const StaffPullForwardListing = () => {
  const { api } = useContext(FirebaseContext);
  const { UpdateListing, fetchAllBranchListings, fetchCurrentAdminsBranchListings } = api;
  ////////////////////////////////////////////////////////////////////
  //Redux
  const dispatch = useDispatch();
  const styles = useStyles();
  // UpdateListing;
  const [state, setState] = useState({
    pullforward: false,
    pullforwardNote: "",
    pullforwardDate: false
  });
  const auth = useSelector((state) => state.auth);
  const navigate = useNavigate();
  const location = useLocation();
  ////////////////////constant////////////////////
  const [details, setdetails] = useState([]);

  useEffect(() => {
    setdetails(location.state.item);
    console.log("details", location.state.item);
  }, []);

  const pullForward = () => {
    let pull = {
      ...details,
      pullforward: {
        pullforward: state.pullforward,
        pullforwardNote: state.pullforwardNote,
        pullforwardDate: new Date(state.pullforwardDate).getTime()
      },
      status: "PullForward"
    };
    try {
      dispatch(UpdateListing(pull));

      console.log("pull", pull);
      alert("Pull forward has been successfully created")
      dispatch(fetchCurrentAdminsBranchListings())
      navigate(-1)
    } catch (error) {
      console.log(error.message);
    }
  };
  const renderListingData = () => {
    return (
      <>
        <div className={styles.root}>
          <Card className={styles.Card}>
            <CardTitle className={styles.CardHeader}>
              Property Details
              <div className={styles.separator} />
            </CardTitle>
            <CardBody style={{ margin: 20 }}>
              <FormGroup>
                <div className={styles.detialsSmokey}>
                  <p className={styles.InfoDescriptionText}>Property Size</p>

                  <p className={styles.InfoText}>{details?.floorSize} ㎡</p>
                </div>
                <div className={styles.detials}>
                  <p className={styles.InfoDescriptionText}>Type of Property</p>

                  <p className={styles.InfoText}>{details?.typeOfProperty}</p>
                </div>
                <div className={styles.detialsSmokey}>
                  <p className={styles.InfoDescriptionText}>Description</p>

                  <p className={styles.InfoText}>{details?.description}</p>
                </div>
                <div className={styles.detials}>
                  <p className={styles.InfoDescriptionText}>Stock id</p>

                  <p className={styles.InfoText}>{details?.id}</p>
                </div>
                <div className={styles.detialsSmokey}>
                  <p className={styles.InfoDescriptionText}>Erf number</p>

                  <p className={styles.InfoText}>{details?.erf}</p>
                </div>
                <div className={styles.detials}>
                  <p className={styles.InfoDescriptionText}>Deposit Amount</p>
                  <p className={styles.InfoText}>{details?.deposit}</p>
                </div>
                <div className={styles.detialsSmokey}>
                  <p className={styles.InfoDescriptionText}>Lease Period</p>

                  <p className={styles.InfoText}>{details?.leaseperiod}</p>
                </div>
                <div className={styles.detials}>
                  <p className={styles.InfoDescriptionText}>Available from</p>

                  <p className={styles.InfoText}>{details?.availableFrom}</p>
                </div>
              </FormGroup>
            </CardBody>
          </Card>
          <Card className={styles.Card}>
            <CardTitle className={styles.CardHeaderTwo}>
              Pull Forward
              <div className={styles.separatorTwo} />
            </CardTitle>
            <CardBody>
              <FormGroup>
                <Label
                  check
                  className={styles.radioText}
                  style={{
                    color: STYLES.WEB_APP_FONT_CLR
                    // marginTop: 45,
                    // margin: "10px 0 0 1px",
                  }}
                >
                  <Input
                    type="radio"
                    name="radio1"
                    style={{
                      marginLeft: 25,
                      borderColor:STYLES.PRIMARY_APP_CLR,
                      borderWidth: 2,
                      height: 25,
                      width: 25,
                      marginTop: -4,
                      marginRight: 5
                    }}
                    value={state.pullforward}
                    onChange={() => {
                      setState({
                        ...state,
                        pullforward: "Renew Lease"
                      });
                    }}
                  />
                  Renew Lease
                </Label>
                <Label
                  check
                  className={styles.radioText}
                  style={{
                    color: STYLES.WEB_APP_FONT_CLR
                    // marginTop: 45,
                    // margin: "10px 0 0 1px",
                  }}
                >
                  <Input
                    type="radio"
                    name="radio1"
                    style={{
                      marginLeft: 25,
                      borderColor:STYLES.PRIMARY_APP_CLR,
                      borderWidth: 2,
                      height: 25,
                      width: 25,
                      marginTop: -4,
                      marginRight: 5
                    }}
                    value={state.pullforward}
                    onChange={() => {
                      setState({
                        ...state,
                        pullforward: "Not Looking"
                      });
                    }}
                  />
                  Not Looking
                </Label>
                <Label
                  check
                  className={styles.radioText}
                  style={{
                    color: STYLES.WEB_APP_FONT_CLR
                    // marginTop: 45,
                    // margin: "10px 0 0 1px",
                  }}
                >
                  <Input
                    type="radio"
                    name="radio1"
                    style={{
                      marginLeft: 25,
                      borderColor:STYLES.PRIMARY_APP_CLR,
                      borderWidth: 2,
                      height: 25,
                      width: 25,
                      marginTop: -4,
                      marginRight: 5
                    }}
                    value={state.pullforward}
                    onChange={() => {
                      setState({
                        ...state,
                        pullforward: "Other"
                      });
                    }}
                  />
                  Other
                </Label>
              </FormGroup>
              <FormGroup>
                <Input
                  type="date"
                  fullWidth
                  // bsSize="lg"
                  value={state.pullforwardDate}
                  onChange={(event) => {
                    setState({
                      ...state,
                      pullforwardDate: event.target.value
                    });
                  }}
                  style={{
                    fontSize: 15,
                    fontWeight: "400",
                    border: "1px solid",
                    borderColor: STYLES.PRIMARY_APP_CLR,
                    color: STYLES.WEB_APP_FONT_CLR,
                    marginBottom: 5
                  }}
                  customLabelStyles={{
                    colorFocused: STYLES.TERTIARY_APP_CLR,
                    colorBlurred: "black",
                    fontSizeFocused: 12
                  }}
                />
                {state?.pullforward === "Other" ? (
                  <Input
                  type="text"
                  fullWidth
                  // bsSize="lg"
                  placeholder="Add other pull forward reason"
                  value={state.pullforwardNote}
                  onChange={(event) => {
                    setState({
                      ...state,
                      pullforwardNote: event.target.value
                    });
                  }}
                  style={{
                    fontSize: 15,
                    fontWeight: "400",
                    border: "1px solid",
                    borderColor: STYLES.PRIMARY_APP_CLR,
                    color: STYLES.WEB_APP_FONT_CLR
                  }}
                  customLabelStyles={{
                    colorFocused: STYLES.TERTIARY_APP_CLR,
                    colorBlurred: "black",
                    fontSizeFocused: 12
                  }}
                />
                ) : null}
                
                <div
                  style={{
                    alignSelf: "center",
                    marginTop: 10
                  }}
                >
                  <Button
                    style={{
                      fontSize: 15,
                      fontWeight: "400",
                      backgroundColor: STYLES.WEB_APP_FONT_CLR
                    }}
                    onClick={() => pullForward()}
                  >
                    Pull Forward
                  </Button>
                </div>
              </FormGroup>
            </CardBody>
          </Card>
        </div>
      </>
    );
  };

  return <>{renderListingData()}</>;
};

export default StaffPullForwardListing;
